import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin, Phone, Mail, Star } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-gray-dark text-white pt-16 pb-24 md:pb-8 font-body" data-id="element-136">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-138">
          {/* Col 1: Brand & Contact */}
          <div data-id="element-139">
            <div className="flex items-center gap-3 mb-6" data-id="element-140">
              <div className="w-12 h-12 rounded-full bg-brand-blue flex items-center justify-center border-2 border-white" data-id="element-141">
                <span className="font-heading font-bold text-xl text-white" data-id="element-142">
                  M
                </span>
              </div>
              <div data-id="element-143">
                <h3 className="font-heading font-bold text-lg leading-tight" data-id="element-144">
                  Moceri
                </h3>
                <p className="text-xs text-gray-300" data-id="element-145">
                  Residential Services LLC
                </p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-146">
              Macomb & St. Clair County's most trusted exterior contractor.
              Licensed, insured, and delivering quality craftsmanship since
              2009.
            </p>
            <div className="space-y-3 text-sm text-gray-300" data-id="element-147">
              <a href="tel:5862033701" className="flex items-center gap-3 hover:text-brand-blue transition-colors" data-id="element-148">
                <Phone size={18} className="text-brand-blue" data-id="element-149" />
                (586) 203-3701
              </a>
              <a href="mailto:MoceriRS@gmail.com" className="flex items-center gap-3 hover:text-brand-blue transition-colors" data-id="element-150">
                <Mail size={18} className="text-brand-blue" data-id="element-151" />
                MoceriRS@gmail.com
              </a>
              <div className="flex items-start gap-3" data-id="element-152">
                <MapPin size={18} className="text-brand-blue shrink-0 mt-1" data-id="element-153" />
                <span data-id="element-154">
                  Harrison Township, MI
                  <br data-id="element-155" />
                  Serving Southeast Michigan
                </span>
              </div>
            </div>
          </div>

          {/* Col 2: Quick Links */}
          <div data-id="element-156">
            <h4 className="font-heading font-bold text-lg mb-6 border-b border-gray-700 pb-2" data-id="element-157">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-158">
              <li data-id="element-159">
                <Link to="/" className="hover:text-brand-blue transition-colors" data-id="element-160">
                  Home
                </Link>
              </li>
              <li data-id="element-161">
                <Link to="/about" className="hover:text-brand-blue transition-colors" data-id="element-162">
                  About Us
                </Link>
              </li>
              <li data-id="element-163">
                <Link to="/gallery" className="hover:text-brand-blue transition-colors" data-id="element-164">
                  Project Gallery
                </Link>
              </li>
              <li data-id="element-165">
                <Link to="/reviews" className="hover:text-brand-blue transition-colors" data-id="element-166">
                  Customer Reviews
                </Link>
              </li>
              <li data-id="element-167">
                <Link to="/financing" className="hover:text-brand-blue transition-colors" data-id="element-168">
                  Financing Options
                </Link>
              </li>
              <li data-id="element-169">
                <Link to="/storm-damage" className="hover:text-brand-blue transition-colors" data-id="element-170">
                  Storm Damage
                </Link>
              </li>
              <li data-id="element-171">
                <Link to="/blog" className="hover:text-brand-blue transition-colors" data-id="element-172">
                  Blog & Resources
                </Link>
              </li>
              <li data-id="element-173">
                <Link to="/contact" className="hover:text-brand-blue transition-colors" data-id="element-174">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Services */}
          <div data-id="element-175">
            <h4 className="font-heading font-bold text-lg mb-6 border-b border-gray-700 pb-2" data-id="element-176">
              Our Services
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-177">
              <li data-id="element-178">
                <Link to="/services/roofing" className="hover:text-brand-blue transition-colors" data-id="element-179">
                  Roofing & Repairs
                </Link>
              </li>
              <li data-id="element-180">
                <Link to="/services/gutters" className="hover:text-brand-blue transition-colors" data-id="element-181">
                  Gutter Services
                </Link>
              </li>
              <li data-id="element-182">
                <Link to="/services/siding" className="hover:text-brand-blue transition-colors" data-id="element-183">
                  Siding Installation
                </Link>
              </li>
              <li data-id="element-184">
                <Link to="/services/windows" className="hover:text-brand-blue transition-colors" data-id="element-185">
                  Window Replacement
                </Link>
              </li>
              <li data-id="element-186">
                <Link to="/services/painting" className="hover:text-brand-blue transition-colors" data-id="element-187">
                  Exterior Painting
                </Link>
              </li>
              <li data-id="element-188">
                <Link to="/commercial" className="hover:text-brand-blue transition-colors" data-id="element-189">
                  Commercial Roofing
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Service Areas */}
          <div data-id="element-190">
            <h4 className="font-heading font-bold text-lg mb-6 border-b border-gray-700 pb-2" data-id="element-191">
              Service Areas
            </h4>
            <div className="space-y-4 text-sm text-gray-400" data-id="element-192">
              <div data-id="element-193">
                <strong className="text-white block mb-1" data-id="element-194">
                  St. Clair County
                </strong>
                <p data-id="element-195">Port Huron, Marysville, St. Clair...</p>
              </div>
              <div data-id="element-196">
                <strong className="text-white block mb-1" data-id="element-197">Macomb County</strong>
                <p data-id="element-198">Harrison Twp, Clinton Twp, Macomb...</p>
              </div>
              <div data-id="element-199">
                <strong className="text-white block mb-1" data-id="element-200">
                  Oakland County
                </strong>
                <p data-id="element-201">Troy, Rochester Hills, Auburn Hills...</p>
              </div>
              <Link to="/areas" className="inline-block mt-2 text-brand-blue hover:text-white transition-colors font-medium" data-id="element-202">
                View All Areas &rarr;
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-203">
          <div className="text-gray-500 text-sm text-center md:text-left" data-id="element-204">
            &copy; {new Date().getFullYear()} Moceri Residential Services LLC.
            All rights reserved.
            <br className="md:hidden" data-id="element-205" />
            <span className="hidden md:inline" data-id="element-206"> | </span> Licensed Builder |
            Harrison Township, MI
          </div>
          <div className="flex items-center gap-4" data-id="element-207">
            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 hover:bg-brand-blue hover:text-white transition-all" data-id="element-208">
              <Facebook size={20} data-id="element-209" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 hover:bg-brand-blue hover:text-white transition-all" data-id="element-210">
              <Instagram size={20} data-id="element-211" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 hover:bg-brand-blue hover:text-white transition-all" data-id="element-212">
              <Star size={20} data-id="element-213" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}